export default __webpack_public_path__ + "static/media/StuonB2.d59ada38.png";